<template>
	<div class="animated fadeIn">
		<div class="container">
			<user-data-form
				:form-import="form"
				:create-new-user="true"
				:errors-import="errors.errors"
				:statuses="statuses"
				:processing="processing"
				@requestData="requestNewUser" />
		</div>
	</div>
</template>
<script>

import User from '@/util/User';
import { STATUSES as statuses } from '@/settings/Statuses';
import { Validations as messages } from '@/translations';
import UserDataForm from './components/UserDataForm';

export default {
	name: 'NewCustomer',
	messages,
	components: {
		UserDataForm,
	},
	data() {
		return {
			corporate: new User(),
			statuses,
			form: {
				username: '',
				email: '',
				first_name: '',
				last_name: '',
				status: 'active',
				type: 'customer',
				mobile_number: '',
				password: '',
				password_confirmation: '',
			},
			alert: new this.$Alert(),
			processing: false,
		};
	},
	computed: {
		errors() {
			return this.corporate.data.errors;
		},
	},
	methods: {
		requestNewUser(payload) {
			this.processing = true;
			this.corporate.createUser(payload).then(() => {
				try {
					this.alert.toast('success', this.translate('ccustomer_created'));
				} finally {
					this.$router.push({ name: 'Customers' });
				}
			})
				.catch(() => { this.data = payload; })
				.finally(() => {
					this.processing = false;
				});
		},
	},
};
</script>
